import { render, staticRenderFns } from "./ConceptHierarchy.vue?vue&type=template&id=739a7bff"
import script from "./ConceptHierarchy.vue?vue&type=script&lang=js"
export * from "./ConceptHierarchy.vue?vue&type=script&lang=js"
import style0 from "./ConceptHierarchy.vue?vue&type=style&index=0&id=739a7bff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports